


















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import OzMembershipTierGrid from 'library/v4/components/OzMembershipTierGrid.vue'

export enum Variant {
  Upgrade,
  Loading,
  Continue,
  ContinueOld,
  UpgradeOld,
  SignUp,
}

@Component({ components: { OzBox, OzContainedButton, OzIcon, OzLoadingSpinner, OzMembershipTierGrid } })
export default class PlatinumMembershipTier extends Vue {
  /**
   * Defines which variant should be displayed.
   */
  @Prop({ required: true }) variant!: Variant

  /**
   * Determines whether the OzMembershipTierGrid component should be expanded or not.
   */
  @Prop({ required: true }) isExpanded!: boolean

  /**
   * Determines whether the plan information is being loaded or not.
   */
  @Prop({ required: true }) isLoadingPlanInformation!: boolean

  /**
   * The plan's monthly price.
   */
  @Prop({ required: true }) monthlyPrice!: string

  /**
   * The plan's annual price.
   */
  @Prop({ required: true }) annualPrice!: string

  /**
   * Determines whether to show the checkmark next to the tier name or not.
   */
  @Prop({ default: false }) xChecked!: boolean

  /**
   * The maximum upload file size allowed in this Tier.
   */
  @Prop({ required: true }) advertisedFileSizeQuota!: string

  /**
   * Whether Advertised Quotas have been fetched.
   */
  @Prop({ required: true }) isLoadingAdvertisedQuotas!: boolean

  /**
   * Whether the user is logged in or not. Used by the "SignUp" variant.
   */
  @Prop() isUserLoggedIn?: boolean

  OzContainedButtonColorScheme = OzContainedButtonColorScheme
  OzContainedButtonSizePreset = OzContainedButtonSizePreset
  Variant = Variant

  get isOldVariant(): boolean {
    return this.variant === Variant.ContinueOld || this.variant === Variant.UpgradeOld
  }

  get colorScheme(): OzBoxColors | null {
    if (this.variant === Variant.Upgrade || this.variant === Variant.Loading || this.variant === Variant.Continue)
      return OzBoxColors.Green
    if (this.variant === Variant.ContinueOld || this.variant === Variant.UpgradeOld) return OzBoxColors.Pink
    return null
  }
}
